import { gsap } from "gsap";

export const init = () => {
  const trigger = document.querySelector(".js-menu-trigger");
  if (!trigger) return;

  const modal = document.getElementById("modal-menu");
  if (!modal) return;

  const close = document.querySelectorAll(".js-menu-close");
  const content = modal.querySelector(".nav-principal");

  const tl = gsap.timeline({
    paused: true,
    defaults: {
      duration: 0.6,
      ease: "power2.out",
    },
    onReverseComplete: () => {
      modal.classList.remove("is-open");
    },
  });

  tl.fromTo(content, { y: "-100%" }, { y: "0%" });

  const open = () => {
    modal.classList.add("is-open");
    document.documentElement.classList.add("is-menu-open");
    document.body.classList.add("is-menu-open");

    if (window.lenis && typeof window.lenis.stop === "function") {
      window.lenis.stop();
    }

    modal.setAttribute("aria-hidden", "false");
    tl.play(0);
  };

  const closeMenu = () => {
    document.documentElement.classList.remove("is-menu-open");
    document.body.classList.remove("is-menu-open");

    if (window.lenis && typeof window.lenis.start === "function") {
      window.lenis.start();
    }

    modal.setAttribute("aria-hidden", "true");
    tl.reverse();
  };

  trigger.addEventListener("click", (e) => {
    e.preventDefault();
    open();
  });
  close.forEach((el) => el.addEventListener("click", closeMenu));
}
